var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"selfService"}},[_c('v-container',{staticClass:"text-center"},[_c('p',{staticClass:"subHead"},[_vm._v("More of the do it yourself type?")]),_c('p',{staticClass:"mainHead"},[_vm._v("Visit one of our self service bays")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }